import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <Helmet>
        <title>Hinnasto - Kotipalveluiden hinnat Lahdessa 38€/tunti | Sipelius Kotipalvelu</title>
        <meta name="description" content="Sipelius Kotipalvelun hinnasto: kaikki palvelut 38€/tunti. ALV 0% -mahdollisuus senioreille. Kotisiivous, senioriapu ja henkilökohtainen apu Lahdessa. Pyydä tarjous!" />
        <meta name="keywords" content="kotipalvelu hinta Lahti, kotisiivous hinta, senioriapu hinta, senioripalvelut Lahti, 38 euroa tunti, ALV 0 prosentti, kotipalvelu tarjous Lahti" />
        <link rel="canonical" href="https://sipelius-kotipalvelu.fi/hinnasto" />
        <meta property="og:title" content="Hinnasto - Kotipalveluiden hinnat Lahdessa 38€/tunti" />
        <meta property="og:description" content="Sipelius Kotipalvelun hinnasto: kaikki palvelut 38€/tunti. ALV 0% -mahdollisuus senioreille. Kotisiivous, senioriapu ja henkilökohtainen apu Lahdessa." />
        <meta property="og:url" content="https://sipelius-kotipalvelu.fi/hinnasto" />
        <meta property="og:type" content="website" />
      </Helmet>
      <section className="about-hero">
          <h1>Hinnasto</h1>
      </section>

      <section className="pricing-section">
        <div className="container">
          <div className="pricing-intro">
            <h2>Palveluhinnasto</h2>
            <p>
              Kaikki palveluni ovat saatavilla 38 €/tunti.
            </p>
          </div>

          <div className="pricing-grid">
            <div className="pricing-card">
              <div className="pricing-header">
                <h3>Kodinhoito</h3>
                <div className="price">
                  <span className="amount">38€</span>
                  <span className="period">/tunti</span>
                </div>
              </div>
              <div className="pricing-features">
                <ul>
                  <li>Perusteellinen siivous</li>
                  <li>Pintojen pyyhkiminen</li>
                  <li>Imurointi ja lattioiden pesu</li>
                  <li>Keittiön ja kylpyhuoneen siivous</li>
                  <li>Ikkunoiden puhdistus</li>
                  <li>Roskien vieminen</li>
                </ul>
              </div>
              <div className="pricing-note">
                <p>Minimi 1 tunti</p>
              </div>
            </div>

            <div className="pricing-card featured">
              <div className="pricing-header">
                <h3>Senioriapu</h3>
                <div className="price">
                  <span className="amount">38€</span>
                  <span className="period">/tunti</span>
                </div>
              </div>
              <div className="pricing-features">
                <ul>
                  <li>Asiointiavustus</li>
                  <li>Seura ja keskustelu</li>
                  <li>Henkilökohtainen tuki</li>
                  <li>Pukeutumisapu</li>
                  <li>Peseytymisapu</li>
                </ul>
              </div>
              <div className="pricing-note">
                <p>Minimi 1 tunti</p>
              </div>
            </div>

            <div className="pricing-card">
              <div className="pricing-header">
                <h3>Henkilökohtainen apu</h3>
                <div className="price">
                  <span className="amount">38€</span>
                  <span className="period">/tunti</span>
                </div>
              </div>
              <div className="pricing-features">
                <ul>
                  <li>Ruokakauppaan ja asiointiin</li>
                  <li>Lääkärikäynnit</li>
                  <li>Pankki- ja virastoasiointi</li>
                  <li>Kodin järjestely</li>
                  <li>Seura ja aktiviteetit</li>
                  <li>Yksilöllinen palvelu</li>
                </ul>
              </div>
              <div className="pricing-note">
                <p>Minimi 1 tunti</p>
              </div>
            </div>
          </div>

          <div className="pricing-info">
            <h3>Lisätietoja hinnoittelusta</h3>
            <div className="info-grid">
              <div className="info-item">
                <h4>ALV 0% -palvelusopimus</h4>
                <p>Palvelusopimuksen laadinta onnistuu ilmaisella arviointikäynnillä tai tarvittaessa puhelimitse.</p>
              </div>
              <div className="info-item">
                <h4>Matkakulut</h4>
                <p>Lahden kaupunkialueen ulkopuolella veloitan kilometrikorvauksen 0,59 €/km (sis. ALV 25,5 %).</p>
              </div>
              <div className="info-item">
                <h4>Maksutavat</h4>
                <p>Voit maksaa palveluni kätevästi sähköpostilaskulla, perinteisellä paperilaskulla tai käteisellä.</p>
              </div>
              <div className="info-item">
                <h4>Vastuuvakuutus</h4>
                <p>Toimintani on vastuuvakuutettu.</p>
              </div>
            </div>
          </div>

          <br />
          <br />
          <div className="alv-info">
            <h3>Arvonlisävero (ALV)</h3>
            <p>
              Hinta sisältää arvonlisäveron (ALV) 25,5 %.
            </p>
            <p>
              Tarjoan palveluitani myös ALV 0 %:lla siihen oikeutetuille henkilöille. 
              Jotta voin myydä palvelun ilman arvonlisäveroa, asiakkaan kanssa on 
              laadittava erillinen palvelusopimus.
            </p>
            <p>
              <strong>Huomioithan, että ALV 0 % -oikeus ei koske piha- ja puutarhatöitä.</strong> 
              Näistä palveluista veloitetaan aina normaali arvonlisävero.
            </p>
          </div>

          <div className="service-guarantee">
            <h3>Yksilöllistä palvelua</h3>
            <p>
              Kun valitset minut, saat aina yksilöllistä palvelua suomeksi – suoraan minulta, 
              ilman vaihtuvia työntekijöitä. <Link to="/palvelut">Tutustu kaikkiin palveluihini</Link> ja <Link to="/">lue lisää tarinastani</Link>.
            </p>
            <p>
              <strong>Huomaathan, että hoivapalveluni ovat suunnattu ensisijaisesti senioreille.</strong>
            </p>
          </div>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <h2>Haluatko tarkemman tarjouksen?</h2>
          <p>
            Ota yhteyttä niin keskustellaan tarpeistasi ja teen sinulle 
            yksilöllisen tarjouksen juuri sinun tilanteeseesi sopivaksi.
          </p>
          <div className="contact-buttons">
            <a href="mailto:sipeliuskotipalvelu@gmail.com" className="contact-button primary">
              Pyydä tarjous
            </a>
            <a href="tel:0442465506" className="contact-button secondary">
              Soita nyt
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 